module.exports = __webpack_public_path__ + "static/media/desktopScreenshot05.fc601806.jpg";